import React, { useEffect, useState } from 'react'
import { format } from "date-fns";
import { parseToNumber, sleep } from "../../utils/helper";
import { Button, Thead, Tbody, Tr, Td, Input, Flex, Text, Box, IconButton, AlertDialog, Center, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, HStack, useDisclosure, Tooltip } from "@chakra-ui/react";
import { Table } from "@chakra-ui/react";
import { TiDelete, BiServer } from "react-icons/all";
import "./TouristByAgent.css";
import { touristByAgentColumn } from '../../constants/tableData';

function TouristByAgentTable({ data, filter, status, onSaveAll, onRevertAll, isAllowAdd, isAllowEdit }) {
    const [selected, setSelected] = useState([]);
    const { isOpen: isDeleteModalOpen, onOpen: onDeleteModalOpen, onClose: onDeleteModalClose } = useDisclosure();
    useEffect(() => {
        //map all column and sum total of the colum
        touristByAgentColumn.forEach((column) => {
            _calcSubTotal(column.columnId);
        })
    }, [])
    // This function is use to calculate the value in all the input when on key up
    const _calcPayRaise = (id) => {
        let teenager1DayTicket = parseInt(document.getElementById(`tourist-by-agent-teenager1DayTicket-${id}`).value);
        let adult1DayTicket = parseInt(document.getElementById(`tourist-by-agent-adult1DayTicket-${id}`).value);
        let pensioner1DayTicket = parseInt(document.getElementById(`tourist-by-agent-pensioner1DayTicket-${id}`).value);
        let teenager3DaysTicket = parseInt(document.getElementById(`tourist-by-agent-teenager3DaysTicket-${id}`).value);
        let adult3DaysTicket = parseInt(document.getElementById(`tourist-by-agent-adult3DaysTicket-${id}`).value);
        let pensioner3DaysTicket = parseInt(document.getElementById(`tourist-by-agent-pensioner3DaysTicket-${id}`).value);
        let teenager7DaysTicket = parseInt(document.getElementById(`tourist-by-agent-teenager7DaysTicket-${id}`).value);
        let adult7DaysTicket = parseInt(document.getElementById(`tourist-by-agent-adult7DaysTicket-${id}`).value);
        let pensioner7DaysTicket = parseInt(document.getElementById(`tourist-by-agent-pensioner7DaysTicket-${id}`).value);

        // check if the value is 
        if (isNaN(teenager1DayTicket)) { teenager1DayTicket = 0 }
        if (isNaN(adult1DayTicket)) { adult1DayTicket = 0 }
        if (isNaN(pensioner1DayTicket)) { pensioner1DayTicket = 0 }
        if (isNaN(teenager3DaysTicket)) { teenager3DaysTicket = 0 }
        if (isNaN(adult3DaysTicket)) { adult3DaysTicket = 0 }
        if (isNaN(pensioner3DaysTicket)) { pensioner3DaysTicket = 0 }
        if (isNaN(teenager7DaysTicket)) { teenager7DaysTicket = 0 }
        if (isNaN(adult7DaysTicket)) { adult7DaysTicket = 0 }
        if (isNaN(pensioner7DaysTicket)) { pensioner7DaysTicket = 0 }

        // Temporary variable use for calculate
        let totalTeenagerTicketTmp = 0;
        let totalAdultTicketTmp = 0;
        let totalPensionerTicketTmp = 0;

        // total 
        totalTeenagerTicketTmp = teenager1DayTicket + teenager3DaysTicket + teenager7DaysTicket;
        totalAdultTicketTmp = adult1DayTicket + adult3DaysTicket + adult7DaysTicket;
        totalPensionerTicketTmp = pensioner1DayTicket + pensioner3DaysTicket + pensioner7DaysTicket;


        // call Input field for display to UI
        let totalTeenagerTicket = document.getElementById(`tourist-by-agent-totalTeenagerTicket-${id}`);
        let totalAdultTicket = document.getElementById(`tourist-by-agent-totalAdultTicket-${id}`);
        let totalPensionerTicket = document.getElementById(`tourist-by-agent-totalPensionerTicket-${id}`);


        // display to UI
        totalTeenagerTicket.value = totalTeenagerTicketTmp;
        totalAdultTicket.value = totalAdultTicketTmp;
        totalPensionerTicket.value = totalPensionerTicketTmp;

        touristByAgentColumn.forEach((column) => {
            _calcSubTotal(column.columnId);
        })
    }

    // This function use to set input value to 0 when the input is empty
    const _invalidValue = (columnId, id) => {
        let inputValue = document.getElementById(`tourist-by-agent-${columnId}-${id}`);
        if (inputValue.value === "") {
            inputValue.value = 0;
        } else {
            inputValue.value = parseInt(inputValue.value)
        }
    }

    // This function is use to calculate Total value
    const _calcSubTotal = (column) => {
        let subColumn = document.getElementsByClassName(`tourist-by-agent-${column}`);

        let total = 0;
        for (let each of subColumn) {
            if (each.value === "") { each.value = 0 }
            if (!isNaN(parseInt(each.value))) {
                total += parseInt(each.value)
            } else {
                total += parseToNumber(each.value)
            }
        }

        let totalColumn = document.getElementById(`total-tourist-by-agent-${column}`);
        if (totalColumn) {
            totalColumn.innerHTML = total;
        }
    };
    return (
        <>
            <AlertDialog motionPreset="slideInBottom" isOpen={isDeleteModalOpen} isCentered>
                <AlertDialogOverlay />

                <AlertDialogContent>
                    <AlertDialogHeader fontSize="lg">Confirmation</AlertDialogHeader>

                    <AlertDialogBody>
                        {`Are you sure you want to revert ${selected.length > 1 ? "these tourist by agents?" : "this tourist by agent?"}`}
                    </AlertDialogBody>
                    <AlertDialogFooter>
                        <HStack spacing="2">
                            <Button onClick={onDeleteModalClose}>No</Button>
                            <Button
                                colorScheme="red"
                                onClick={async () => {
                                    onRevertAll(selected)
                                    await sleep(100);
                                    onDeleteModalClose();
                                }}
                            >Yes</Button>
                        </HStack>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialog>

            <Box style={{ position: "sticky", left: "0" }} w="100%" mb="10px">
                <Text textAlign="center" fontSize="25px" fontWeight="bold">International Tourist By Tour Agent or FIT</Text>
                {status === "filter" ? (
                    <Text textAlign="center">Tourist By Tour Agent or FIT from {format(new Date(filter?.dateFrom), "dd MMMM, yyyy")} to {format(new Date(filter?.dateTo), "dd MMMM, yyyy")}</Text>
                ) : status === "import" ? (
                    <Text textAlign="center">Tourist By Tour Agent or FIT from {data?.length > 0 && format(new Date(data[0]?.date), "dd MMMM, yyyy")} {/* to {data?.length > 0 && format(new Date(data[data?.length - 1]?.date), "dd MMMM, yyyy")} */}</Text>
                ) : status === "retrieve" && filter !== undefined ? (
                    <Text textAlign="center">Tourist By Tour Agent or FIT from {format(new Date(filter?.dateFrom), "dd MMMM, yyyy")} to {format(new Date(filter?.dateTo), "dd MMMM, yyyy")}</Text>
                ) : ""}
            </Box>

            {data?.length > 0 ? (
                <Table w="2000px" size="sm" className="agent-table" borderRight="1px solid black">
                    <Thead className='agent-thead'>
                        <Tr color="#4149BE" fontWeight="bold" className='agent-thead-tr1'>
                            <Td rowSpan="4" color='white' colSpan="1" textAlign="center">ល.រ</Td>
                            <Td rowSpan="3" color='white' colSpan="1" textAlign="center">TOUR AGENT</Td>
                            <Td rowSpan="1" color='white' colSpan="3" textAlign="center">ទស្សនា ០១ ថ្ងៃ</Td>
                            <Td rowSpan="1" colSpan="3" textAlign="center" px="0">ទស្សនា ០៣ ថ្ងៃ</Td>
                            <Td rowSpan="1" colSpan="3" textAlign="center" px="0">ទស្សនា ០៧ ថ្ងៃ</Td>
                            <Td rowSpan="1" colSpan="4" textAlign="center" px="0">សរុបតាមអាយុ</Td>
                            <Td rowSpan="4" colSpan="1" textAlign="center" px="0">ស្ថានភាព</Td>
                        </Tr>
                        <Tr color="#4149BE" fontWeight="bold" textAlign="center" h="35px" className='agent-thead-tr2'>
                            <Td rowSpan="1" colSpan="1" textAlign="center">យុវជន</Td>
                            <Td rowSpan="1" colSpan="1" textAlign="center">វ័យកណ្ដាល</Td>
                            <Td rowSpan="1" colSpan="1" textAlign="center">និវត្តន៍ជន</Td>
                            <Td rowSpan="1" colSpan="1" textAlign="center">យុវជន</Td>
                            <Td rowSpan="1" colSpan="1" textAlign="center">វ័យកណ្ដាល</Td>
                            <Td rowSpan="1" colSpan="1" textAlign="center">និវត្តន៍ជន</Td>
                            <Td rowSpan="1" colSpan="1" textAlign="center">យុវជន</Td>
                            <Td rowSpan="1" colSpan="1" textAlign="center">វ័យកណ្ដាល</Td>
                            <Td rowSpan="1" colSpan="1" textAlign="center">និវត្តន៍ជន</Td>
                            <Td rowSpan="1" colSpan="1" textAlign="center">យុវជន</Td>
                            <Td rowSpan="1" colSpan="1" textAlign="center">វ័យកណ្ដាល</Td>
                            <Td rowSpan="1" colSpan="1" textAlign="center">និវត្តន៍ជន</Td>
                            <Td rowSpan="1" colSpan="1" textAlign="center">សរុបរួម</Td>

                        </Tr>
                        <Tr color="#4149BE" fontWeight="bold" textAlign="center" h="35px" className='agent-thead-tr3'>
                            <Td textAlign="center" p="0">12 - 25</Td>
                            <Td textAlign="center" p="0">26 - 59</Td>
                            <Td textAlign="center" p="0">60 Up</Td>
                            <Td textAlign="center" p="0">12 - 25</Td>
                            <Td textAlign="center" p="0">26 - 59</Td>
                            <Td textAlign="center" p="0">60 Up</Td>
                            <Td textAlign="center" p="0">12 - 25</Td>
                            <Td textAlign="center" p="0">26 - 59</Td>
                            <Td textAlign="center" p="0">60 Up</Td>
                            <Td textAlign="center" p="0">12 - 25</Td>
                            <Td textAlign="center" p="0">26 - 59</Td>
                            <Td textAlign="center" p="0">60 Up</Td>
                            <Td textAlign="center" p="0">All Age</Td>
                        </Tr>
                        <Tr color="#4149BE" fontWeight="bold" textAlign="center" h="35px" className='agent-thead-tr4'>
                            <Td textAlign="center" p="0">TOUR AGENT</Td>
                            <Td textAlign="center" p="0">T1D</Td>
                            <Td textAlign="center" p="0">A1D</Td>
                            <Td textAlign="center" p="0">P1D</Td>
                            <Td textAlign="center" p="0">T3D</Td>
                            <Td textAlign="center" p="0">A3D</Td>
                            <Td textAlign="center" p="0">P3D</Td>
                            <Td textAlign="center" p="0">T7D</Td>
                            <Td textAlign="center" p="0">A7D</Td>
                            <Td textAlign="center" p="0">P7D</Td>
                            <Td textAlign="center" p="0">ALL T</Td>
                            <Td textAlign="center" p="0">ALL A</Td>
                            <Td textAlign="center" p="0">ALL P</Td>
                            <Td textAlign="center" p="0">ALL Age</Td>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {data?.map((data, index) => {
                            return (
                                <Tr key={index} h="25px">
                                    {touristByAgentColumn.map((item, i) => {
                                        return (
                                            <Td key={i} w={item.columnId === "n" ? "40px" : item.columnId === "tourAgent" ? "200px" : "100px"} backgroundColor={(item.columnId === 'n' || item.columnId === 'tourAgent') ? 'white' : ''} py="0" p="1">
                                                <Input
                                                    padding="2px"
                                                    width="100%"
                                                    height="30px"
                                                    textAlign="center"
                                                    borderColor='gray.300'
                                                    type={item.type}
                                                    className={`tourist-by-agent-${item.columnId} ${item.readOnly ? "is-disable-input" : data.status === 1 ? "is-disable-input" : ""}`}
                                                    id={`tourist-by-agent-${item.columnId}-${data.id}`}
                                                    defaultValue={data[item.columnId]}
                                                    onKeyUp={() => _calcPayRaise(`${data.id}`)}
                                                    onBlur={() => { _invalidValue(item.columnId, data.id) }}
                                                />
                                            </Td>
                                        )
                                    })}
                                    <Td width="5px" align='center' py="0">
                                        <Flex justifyContent='center'>
                                            <Button
                                                className={data.status === 1 ? "ut-button-dark" : "ut-button-success"}
                                                w="20"
                                                h="30px"
                                                id={`btn-save-${data.id}`}
                                                onClick={() => onSaveAll([data])}
                                                hidden={!isAllowAdd}
                                            >
                                                {data.status === 1 ? "Saved" : "Save"}
                                            </Button>
                                            <Tooltip hasArrow label='Revert' color='black' bg="gray.300">
                                                <IconButton
                                                    onClick={() => {
                                                        onDeleteModalOpen();
                                                        setSelected([data])
                                                    }}
                                                    id={`btn-revert-${data.id}`}
                                                    className={data.status !== 1 ? "is-disable" : ""}
                                                    variant="ghost"
                                                    colorScheme="red"
                                                    size="sm"
                                                    icon={<TiDelete size="1.7rem" />}
                                                    hidden={!isAllowEdit}
                                                />
                                            </Tooltip>
                                        </Flex>
                                    </Td>
                                </Tr>
                            )
                        })}
                        <Tr h="35px">
                            {touristByAgentColumn.map((item, i) => {
                                return (
                                    <Td key={i} p="0" style={{ backgroundColor: "#8497b0", color: "white", textAlign: "center" }}>
                                        {i === 1 ? "Total" : i === 0 ? null : <span id={`total-tourist-by-agent-${item.columnId}`} />}
                                    </Td>
                                )
                            })}
                            <Td p="0" style={{ backgroundColor: "#8497b0" }}></Td>
                        </Tr>
                    </Tbody>
                </Table>
            ) : (
                <Center py="3" w="full" h="70vh" color="gray.400">
                    <BiServer size="1.3rem" /> <Text fontSize="md">&nbsp;No data.</Text>
                </Center>
            )}
        </>
    )
}

export default TouristByAgentTable
